import { ModelBase, Property } from '@skylab-shared/core';

export class InventoryStocktakingDocumentItemModel extends ModelBase {
    @Property()
    public no: number;

    @Property()
    public productName: string;

    @Property()
    public productId: number;

    @Property()
    public unitId: number;

    @Property()
    public systemQuantity: number;

    @Property()
    public stocktakingQuantity: number;

    @Property()
    public receiptQuantity: number;

    @Property()
    public issueQuantity: number;

    @Property()
    public salePrice: number;

    @Property()
    public purchasePrice: number;

    @Property({nullable: true})
    public symbol: string;

    @Property({nullable: true})
    public barCode: string;
}
